/* eslint-disable react/no-unknown-property */
import { withStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Header from "components/header";
import BounceLoader from "components/loaders/bounce-loader";

import ROUTES from "config/routing";
import { NAVIGATION } from "pages/constants";
import Button from "pages/flyer/flyerTypePage/components/Button";
import ConfirmationPopUp from "pages/flyer/flyerTypePage/components/ConfirmationPopUp";
import { useGetDataForPage } from "pages/flyer/flyerTypePage/useGetDataForPage";
import { useGetFlyerInfo } from "pages/flyer/flyerTypePage/useGetFlyerInfo";
import React, { memo } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router";
import { generatePath } from "react-router-dom";
import style from "./style";
import { useStore } from "../../../store";
import { StoreType } from "../../../store/types";

const SelectFlyerTypePage: React.FC<{ classes: any }> = ({ classes }) => {
  const flyerInfo = useGetFlyerInfo();
  const {
    campaign: { id: campaignId, campaignName },
    client: { id: clientId },
    user: { id: userId },
  }: StoreType = useStore();

  const history = useHistory();

  const {
    firstLevelHeaderComponent,
    secondLevelHeaderComponent,
    buttons,
    isConfirmationModalOpen,
    setIsConfirmationModalOpen,
  } = useGetDataForPage(flyerInfo.pageState);

  const headerActions = {
    BACK: {
      action: async () => {
        history.push(generatePath(ROUTES.CAMPAIGN_AUDIENCE, { campaignId, clientId }));
      },
    },
  };

  return (
    <div className={classes.wrapper}>
      <Helmet>
        <title>Flyer</title>
      </Helmet>
      <Header tabs={NAVIGATION} activeTabIndex={2} headerActions={headerActions} />
      {flyerInfo.isLoading ? (
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
          <BounceLoader />
        </Box>
      ) : (
        <div className={classes.content}>
          <div className={classes.title} cypress_id="campaignNameTitle">
            {campaignName}
          </div>
          <div className={classes.firstLevelHeader} cypress_id="firstLevelHeader">
            {firstLevelHeaderComponent}
          </div>
          <div className={classes.secondLevelHeader} cypress_id="secondLevelHeader">
            {secondLevelHeaderComponent}
          </div>
          <div className={classes.buttons}>
            {buttons.map((button) => {
              return (
                <Button
                  key={`select_flyer_type_page_${button.title}_button`}
                  title={button.title}
                  description={button.description}
                  image={<button.icon />}
                  action={() => button.action(clientId, userId)}
                  cypressId={`${button.title.toLowerCase().replace(/\s+/g, "-")}-btn`}
                />
              );
            })}
          </div>
          <ConfirmationPopUp isOpen={isConfirmationModalOpen} onClose={() => setIsConfirmationModalOpen(false)} />
        </div>
      )}
    </div>
  );
};

export default memo(withStyles(style)(SelectFlyerTypePage));
